import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f4c9d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = {
  key: 1,
  class: "title"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "container_top" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_message" }, " 이메일 주소를 입력해주세요 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_info" }, " 조합 규약, 매매 계약 문서 송부나 중요한 알림사항 통지 등에 이메일이 사용됩니다. 자주 사용하시는 이메일을 입력해 주세요 ", -1))
const _hoisted_13 = { class: "container_center" }
const _hoisted_14 = { class: "email_box" }
const _hoisted_15 = { class: "input_box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "x_circle",
  src: "/assets/icon/x-circle.png",
  srcset: "/assets/icon/x-circle@2x.png 2x,/assets/icon/x-circle@3x.png 3x"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "list_box" }
const _hoisted_19 = { class: "container_top" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_message" }, " 변경할 이메일을 입력해주세요 ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_info" }, " 조합 규약, 매매 계약 문서 송부나 중요한 알림사항 통지 등에 이메일이 사용됩니다. 자주 사용하시는 이메일을 입력해 주세요 ", -1))
const _hoisted_22 = { class: "container_center" }
const _hoisted_23 = { class: "email_box" }
const _hoisted_24 = { class: "input_box" }
const _hoisted_25 = { class: "input_info" }
const _hoisted_26 = { class: "input_info" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "change_btn" }, " 변경 ", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "save_btn" }, " 확인 ", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "list_box" }
const _hoisted_33 = { class: "container_top" }
const _hoisted_34 = { class: "info_message" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_info" }, [
  /*#__PURE__*/_createTextVNode(" 이메일로 인증메일을 보내드렸습니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 메일 내용에 있는 "),
  /*#__PURE__*/_createElementVNode("span", { class: "deep-blue" }, "[인증하기]"),
  /*#__PURE__*/_createTextVNode(" 버튼을 눌러주세요! ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container_center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "recertify_box" }, " 인증 메일 다시보내기 ")
], -1))
const _hoisted_37 = { class: "container_top" }
const _hoisted_38 = { class: "info_message" }
const _hoisted_39 = { class: "deep-blue" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub_info" }, " 이메일이 등록되었습니다! 🎉 ", -1))
const _hoisted_41 = { class: "container_bottom" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "google_btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "google_btn_left" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/icon/google_logo.png",
      srcset: "/assets/icon/google_logo@2x.png 2x,/assets/icon/google_logo@3x.png 3x"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "google_btn_right" }, " 구글 이메일 사용 ")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_info" }, " 별도의 인증 절차가 필요하지 않습니다. ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide_box" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "line" }),
  /*#__PURE__*/_createElementVNode("span", null, "or")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_info" }, " 이메일 인증이 필요합니다. ", -1))
const _hoisted_46 = { class: "container_bottom" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "container_bottom" }
const _hoisted_49 = { class: "space-between" }
const _hoisted_50 = { class: "container_bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { fullscreen: true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "ion-activatable ripple-parent btn-back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'뒤로가기'}); _ctx.dismiss()})
              }, [
                _hoisted_5,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ]),
              (_ctx.userEmail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 이메일 변경 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, " 이메일 등록 "))
            ])
          ])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _withDirectives(_createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ion_input, {
                    modelValue: _ctx.userEmail,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userEmail) = $event)),
                    type: "text",
                    placeholder: "이메일",
                    class: "email_input",
                    onKeyup: _ctx.handleInput
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _createElementVNode("div", {
                  class: "clear_btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userEmail = ''))
                }, _hoisted_17)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailAddress, (email) => {
                  return (_openBlock(), _createBlock(_component_ion_list, {
                    key: email,
                    onClick: () => {
                  _ctx.userEmail = `${_ctx.userEmail}@${email}`; 
                  _ctx.emailList = false;}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userEmail) + "@" + _toDisplayString(email), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.emailList]
              ])
            ], 512), [
              [_vShow, _ctx.checkProcessStatus('progress')]
            ])
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('init') || _ctx.checkProcessStatus('progress')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("div", _hoisted_25, " 등록된 이메일 ", 512), [
                    [_vShow, _ctx.emailInput]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_26, " 변경할 이메일 ", 512), [
                    [_vShow, !_ctx.emailInput]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userEmail) = $event)),
                    type: "text",
                    placeholder: "이메일",
                    class: _normalizeClass(["email_input", { email_input_disable : _ctx.emailInput }]),
                    disabled: _ctx.emailInput,
                    onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                  }, null, 42, _hoisted_27), [
                    [_vModelText, _ctx.userEmail]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "change_box",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'이메일 입력 영역', 'clickContent':'변경'}); _ctx.emailInput = false})
                }, _hoisted_29, 512), [
                  [_vShow, _ctx.emailInput]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "change_box",
                  style: {"border-bottom":"1px solid #4360EC"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'이메일 입력 영역', 'clickContent':'확인'}); _ctx.emailInput = true})
                }, _hoisted_31, 512), [
                  [_vShow, !_ctx.emailInput]
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailAddress, (email) => {
                  return (_openBlock(), _createBlock(_component_ion_list, {
                    key: email,
                    onClick: () => {_ctx.userEmail = `${_ctx.userEmail}@${email}`; _ctx.emailList = false;}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userEmail) + "@" + _toDisplayString(email), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.emailList]
              ])
            ])
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('change')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.userEmail), 1),
            _hoisted_35,
            _hoisted_36
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('certify')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.userEmail), 1)
            ]),
            _hoisted_40
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('done')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _hoisted_43,
            _hoisted_44,
            _createElementVNode("div", {
              class: "click_btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setProcessStatus('progress')))
            }, " 이메일 직접 입력 "),
            _hoisted_45
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('init')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "certify_btn",
              disabled: _ctx.verifyEmail,
              onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'이메일 등록하기'}); _ctx.registEmailFunc()})
            }, " 이메일 등록하기 ", 8, _hoisted_47)
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('progress') || _ctx.checkProcessStatus('change')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", {
                class: "previous_btn",
                onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'이전'}); _ctx.setProcessStatus('progress')})
              }, " 이전 "),
              _createElementVNode("div", {
                class: "certify_btn",
                style: {"opacity":"0.3"},
                onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'확인'}); _ctx.setProcessStatus('done')})
              }, " 확인 ")
            ])
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('certify')]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", {
              class: "certify_btn",
              onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':'확인'}); _ctx.emailRegistDone()})
            }, " 확인 ")
          ], 512), [
            [_vShow, _ctx.checkProcessStatus('done')]
          ])
        ])
      ])
    ]),
    _: 1
  }))
}